/**
 * Send hours of the notification schedules. The API stores on-the-hour times
 * only (`HH:00`, see notificationScheduleSchema), so the picker offers exactly
 * the 24 of them in 24-hour form. A browser time input was used before: Chrome
 * with a 12-hour locale showed it in AM/PM form (typing "14" saved 01:00, then 04:00),
 * other browsers offered minutes the page then cut off, and every keystroke
 * was saved. [HW-1071]
 */
export const SEND_HOURS: readonly string[] = Array.from(
  { length: 24 },
  (_, h) => `${String(h).padStart(2, '0')}:00`
);

/** The option a stored send time selects, or undefined when it is not one. */
export function sendHourOption(sendTime: string | null | undefined): string | undefined {
  return sendTime && SEND_HOURS.includes(sendTime) ? sendTime : undefined;
}
